import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const Wrapper = styled.section`
  background-color: #ffffff;
  padding: 4rem 1.5rem;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  max-width: 700px;
  text-align: center;
  animation: fadeIn 0.6s ease-out;
`;

const Title = styled.h1`
  font-size: 2.2rem;
  color: #0077cc;
  margin-bottom: 1.5rem;
`;

const Paragraph = styled.p`
  font-size: 1.15rem;
  color: #444;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const CTAButton = styled.button`
  background-color: #0077cc;
  color: white;
  padding: 0.9rem 2rem;
  font-size: 1.05rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background-color: #005fa3;
  }
`;

export default function ViewAgradecimentoViagem() {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Content>
        <Title>✈️ Interesse registrado com sucesso!</Title>
        <Paragraph>
          Agora que já sabemos para onde e quando você gostaria de viajar, nossa equipe vai ficar de
          olho nas oportunidades ideais para o seu perfil.
        </Paragraph>
        <Paragraph>
          Assim que encontrarmos algo que combine com o que você procura, entraremos em contato com
          você por WhatsApp ou e-mail. 📨
        </Paragraph>
        <Paragraph>Fique tranquilo, você está na nossa lista de prioridade.</Paragraph>

        <CTAButton onClick={() => navigate("/")}>🏠 Voltar para a página inicial</CTAButton>
      </Content>
    </Wrapper>
  );
}
